import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CourseUser } from 'graphqlAPI'
import { joinKeys } from 'helpers/translations.helper'
import {
  createRouteMonitoringParticipant,
  createRouteCourseCertificatesGenerate,
} from 'enum/routes'
import { MonitoringStatus } from 'enum'
import { DropdownLoader } from 'components/ui/DropdownLoader'
import CustomLink from 'components/ui/CustomLink'
import { DropdownButton, styles } from 'components/ui/DropdownButton'
import { prefixTranslation } from './common'

type Data = CourseUser

interface IProps {
  courseUser: Data
  onDelete?(): void
}

const Options: React.FC<IProps> = ({ courseUser }) => {
  const { t } = useTranslation()
  const loading = false
  const [show, setShow] = useState(false)

  const {
    userId,
    courseId,
    advance = MonitoringStatus.Pending,
    certificatesCount,
  } = courseUser
  const handleDropdownClick = (show: boolean) => {
    setShow(show)
  }
  const disabled = advance === MonitoringStatus.Pending

  return (
    <>
      <DropdownButton
        show={show}
        className={styles.actionSelect}
        alignRight
        title={<DropdownLoader loading={loading} />}
        onClick={() => handleDropdownClick(!show)}
        onToggle={() => handleDropdownClick(!show)}
      >
        <CustomLink
          className={styles['option-item']}
          to={createRouteMonitoringParticipant({
            participantId: `${userId}`,
            courseId,
          })}
          disabled={disabled}
        >
          {t(joinKeys(prefixTranslation, 'preview'))}
        </CustomLink>
        <CustomLink
          className={styles['option-item']}
          to={createRouteCourseCertificatesGenerate(
            {
              courseId: courseId,
            },
            {
              users: [userId],
              search: '',
            }
          )}
          disabled={!certificatesCount}
          target="_blank"
        >
          {t('monitoring.course.statistics.table.actions.downloadCertificate', {
            count: certificatesCount || 0,
          })}
        </CustomLink>
      </DropdownButton>
    </>
  )
}

export default Options
